import { render, staticRenderFns } from "./predict-model-popup.vue?vue&type=template&id=66687d50&"
import script from "./predict-model-popup.vue?vue&type=script&lang=js&"
export * from "./predict-model-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports